import React from 'react';
import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
import { Motion } from 'react-motion';
import './SimpleMarker.css';
import { ClustermarkerHOC } from '../clusterMarker/ClusterMarkerHOC';


export const SimpleMarker = ({ defaultMotionStyle, motionStyle }) => (
  <Motion defaultStyle={defaultMotionStyle}
    style={motionStyle}
  >
    {
    ({ scale }) => (
      <div className="marker"
        style={{
          transform: `translate3D(0,0,0) scale(${scale}, ${scale})`,
        }}
      />
    )
  }
  </Motion>
);

export const SimpleMarkerHOC = compose(
  defaultProps({
    defaultScale: 0.6,
    hoveredScale: 0.7,
    initialScale: 0.3,
  }),
  // resuse HOC
  ClustermarkerHOC,
);

export default SimpleMarkerHOC(SimpleMarker);
